import { typeRole, typeVar } from '../typeRoles';

// ----------------------------------------------------------------------
// Form text follows the /dashboard/typography "Forms" roles on public pages
// (falls back to MUI's original body1/caption values in admin).
//
// Line height is deliberately left to MUI on labels and single-line inputs —
// their floating-label offsets and input height are tuned to 1.4375em — and
// only applied to multi-line fields, where it actually affects reading.

export default function Form() {
  return {
    MuiFormLabel: {
      styleOverrides: {
        root: typeRole('form-label', ['fontSize', 'fontWeight', 'textTransform']),
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: typeRole('form-label', ['fontSize', 'fontWeight', 'textTransform']),
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          ...typeRole('form-input', ['fontSize', 'fontWeight']),
          '&.MuiInputBase-multiline': {
            lineHeight: typeVar('form-input', 'line-height', '1.4375em'),
          },
        },
      },
    },
    // The outlined field's notch (the gap in the border behind a shrunk label) is
    // sized from a hidden <legend> at 0.75em of the INPUT font. Labels and inputs
    // now have separate roles, so size it from the label role to keep the gap
    // matched to the shrunk label (MUI shrinks labels to 75%).
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          '& legend': {
            fontSize: `calc(${typeVar('form-label', 'size', '1.0625rem')} * 0.75)`,
            fontWeight: typeVar('form-label', 'weight', 400),
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: typeRole('form-helper'),
      },
    },
  };
}
